import { render } from "./ImagePosition.vue?vue&type=template&id=b365519c"
import script from "./ImagePosition.vue?vue&type=script&lang=js"
export * from "./ImagePosition.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__